














































import axios from "axios"
import Vue, { PropType } from "vue"
import { InfoModel } from "model/InfoModel"
import { vueWith } from "../vueWith"
import { Common } from "./../../common/common"


/**
 *
 * @example
 *  <info-component/>
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: { // 親から渡される値。変更不可
    /** dataに対応するインデックス viewとやり取り時に変換が必要 */
    showDetail: Boolean,
  },
  computed: {
    //
  },
  watch: {
    //
  },
  data() {
    return {
      infoList: [] as InfoModel[],
      loading: false,
    }
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    // this.filter("")

  },

  mounted: function mount() {
    // console.log("mounted")
    // 情報取得
    axios({
      method: "get",
      url: "/info/data",
    }).then((response) => {
      const data = response.data as any
      this.infoList = data
      // console.log(data)

    })
  },

  methods: {

    dt(createdAt: string): string {
      return Common.DateFormat(new Date(createdAt))
    },

    kindColor(kind: number): string {
      const colors = ["", "lightgreen", "lightcoral", "lightblue", "lightgray"]
      return colors[kind]
    },

    kindLabel(kind: number): string {
      const labels = ["", "メンテナンス", "緊急", "更新情報", "お知らせ"]
      return labels[kind]
    },

    /**
     * 追加読み込み
     */
    more() {
      this.loading = true
      axios({
        method: "get",
        url: "/info/data",
        params: {
          offset: this.infoList.length,
        },
      }).then((response) => {
        const data = response.data as any
        this.infoList = this.infoList.concat(data)
        // console.log(data)
        this.loading = false
      })
    },

    // 子から呼ばれる ---------------------------------------------

    // 親へ移譲 ---------------------------------------------

  },
})

